const Footer = () => {
  return <footer className="bg-secondary/90 text-secondary-foreground py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h3 className="text-xl font-bold mb-4">关于产品 解决小语种PDF理解痛点</h3>
            <p className="text-muted-foreground leading-relaxed mb-6">
              精准识别业务中大量国外小语种文档需求，超越简单PDF文档解析，保证格式的翻译。
              作为企业级产品，我们专注企业AI文档智能识别，建议基于LLM的文档AI系统，以人工智能支撑，
              支持高精度识别和格式还原导出，为企业提供专业、高效的文档服务，可快速响应企业个性化定制开发需求。
            </p>
            
            <div className="space-y-2">
              
              <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                
                
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">联系我们</h4>
            <div className="space-y-2 text-muted-foreground">
              <p>商务合作 / 技术咨询 / API接入</p>
              <p className="text-primary">support@Kuaifan.ai</p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">服务链接</h4>
            <div className="space-y-2 text-muted-foreground">
              <p>版权声明与用户协议</p>
              <p>使用条款</p>
              
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-muted-foreground">
          <p>&copy; 2026 Kuaifan. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;